/**
 * Генерация мок данных для демо страницы
 */
import { User } from "./types";

const roles: User["role"][] = ["admin", "user", "guest"];
const statuses: User["status"][] = ["active", "inactive", "pending"];
const names = [
  "Александр",
  "Мария",
  "Иван",
  "Елена",
  "Дмитрий",
  "Ольга",
  "Сергей",
  "Наталья",
];

/**
 * Генерирует массив мок данных пользователей
 */
export const generateMockData = (count: number): User[] =>
  Array.from({ length: count }, (_, i): User => {
    const role = roles[i % roles.length]!;
    const status = statuses[i % statuses.length]!;
    const createdDate = new Date(2024, 0, 1 + i).toISOString().split("T")[0];

    return {
      id: i + 1,
      name: `${names[i % names.length]} ${i + 1}`,
      email: `user${i + 1}@example.com`,
      role,
      age: 20 + (i % 50),
      status,
      createdAt: createdDate!,
    };
  });

export const mockData = generateMockData(100);
